<template>
  <div v-if="summerGuidelines">
    <template v-if="!loading">
      <h1>{{ $lang("2021夏日競技嘉年華") }}</h1>
      <div class="dashed">
        <div class="summer-attention">
          <div v-html="summerGuidelines.content"></div>
        </div>
        <div v-if="isEnroll || isGroup">
          <!-- <p>
                    <span>{{ $lang("TEXT_VIEW_INFORMATION") }}</span>
                </p> -->
          <template v-if="isEnroll">
            <!-- <p>
                        <span>{{ $lang('TEXT_PUBLIC_GROUP') }}</span>
                    </p> -->
            <p>
              <span>{{ $lang("TEXT_VIEW_INFORMATION") }}</span>
              <span
                >（{{
                  records[0].status == "draft"
                    ? $lang("已儲存草稿")
                    : $lang("已成功提交")
                }}）</span
              >
            </p>
            <ul>
              <template v-for="item in records">
                <li v-if="item.status != 'draft'" :key="item.id">
                  <span></span>
                  <router-link
                    class="submitForm"
                    :to="`sport-game/perview/${item.id}`"
                    >{{ item.title }}</router-link
                  >
                </li>
                <li v-else :key="item.id">
                  <span>{{ item.title }}</span>
                  <!-- <router-link class="btn btn-primary" :to="`sport-game/edit/${item.id}`">{{ $lang("修改") }}</router-link> -->
                  <router-link
                    class="btn btn-primary"
                    :to="{
                      path: `sport-game/edit/${item.id}`,
                      query: { isFull: buttonStatus },
                    }"
                    >{{ $lang("修改") }}</router-link
                  >
                  <b-btn variant="info" @click="handlerDelete(item.id)">{{
                    $lang("刪除")
                  }}</b-btn>
                  <!-- <b-btn variant="danger" @click="handlerSumbit(item.id)">{{$lang("提交")}}</b-btn> -->
                  <router-link
                    class="btn btn-danger"
                    :to="`sport-game/edit/${item.id}`"
                    :disabled="buttonStatus"
                    >{{ $lang("提交") }}</router-link
                  >
                </li>
              </template>
            </ul>
          </template>
          <!-- <template v-if="isGroup">
                    <p>
                        <span>{{ $lang('TEXT_PUBLIC_INSTITUTIONS_GROUP') }}</span>
                    </p>
                    <ul>
                        <template v-for="item in groups">
                            <li v-if="item.status != 'draft'" :key="item.id">
                                <span></span>
                                <router-link class="submitForm" :to="`sport-game/perview/${item.id}`">{{ item.title }}</router-link>
                            </li>
                            <li v-else :key="item.id"> -->
          <!-- <span>{{ item.title }}</span>
                                <router-link class="btn btn-primary" :to="`sport-game/edit/${item.id}`">{{ $lang("修改") }}</router-link>
                                <b-btn variant="info" @click="handlerDelete(item.id)">{{$lang("刪除")}}</b-btn> -->
          <!-- <b-btn variant="danger" @click="handlerSumbit(item.id)">{{$lang("提交")}}</b-btn> -->
          <!-- <router-link class="btn btn-danger" :to="`sport-game/edit/${item.id}`">{{ $lang("提交") }}</router-link> -->
          <!-- </li>
                        </template>
                    </ul>
                </template> -->
        </div>
        <template v-if="!buttonStatus">
          <div v-if="!isEnroll || !isGroup">
            <p v-if="!isEnroll">
              <span @click="openModel(1)" class="listen-tnc btn">{{
                $lang("TITLE_ADD_GAME_INFO")
              }}</span>
            </p>
            <!-- <p v-if="!isGroup">
                    <span @click="openModel(2)" class="listen-tnc btn">{{$lang("TITLE_ADD_GAME_INFO_GROUP")}}</span>
                </p> -->
          </div>
        </template>
        <template v-else>
          <p>
            <span>
              <h4>{{ $lang("TITLE_IS_FULL") }}</h4>
            </span>
          </p>
        </template>
      </div>
      <!-- <b-modal ref="tip" :title="$lang('TEXT_TIP_TITLE')">
            <p>{{$lang('報名前請準備以下資料：')}}</p>
            <ol>
                <li>{{$lang('個人身份資料(姓名、出生日期及身份證號碼)')}}</li>
                <li>{{$lang('近照(允許上傳gif,jpg,JPG,jpeg,bmp,png的文件，文件大小限制5M)')}}</li>
                <li>{{$lang('個人健康狀況聲明(滿18歲的報名者可在網上填選，未滿18歲的報名者)')}}<a href="http://www.sport.gov.mo/uploads/wizdownload/201806/18895_ty3pt.pdf" target="_blank">{{$lang('按此下載')}}</a>){{$lang('或由澳門註冊醫生簽署的健康證明')}}</li>
                <b-form-checkbox v-model="isAgree">
                    <span class="lbl">{{$lang('I_AM_AGREE_T_N_C')}}</span>
                </b-form-checkbox>
            </ol>
            <div slot="modal-footer">
                <b-btn variant="info" @click="sumbit" :disabled="!isAgree">{{$lang('BTN_YES')}}</b-btn>
                <b-btn variant="secondary" @click="hideModel">{{$lang('BTN_NO')}}</b-btn>
            </div>
        </b-modal> -->
    </template>
    <template v-else>
      <div class="spinner">
        <b-spinner variant="primary" label="Spinning"></b-spinner>
      </div>
    </template>
  </div>
</template>

<script>
import { $apis } from "@/helper";
import game from "@/components/game";
import List from "@/components/List";
export default {
  components: {
    game,
    List,
  },
  data() {
    return {
      loading: true,
      isReadOnly: true,
      isAgree: false,
      records: [],
      groups: [],
      buttonStatus: false,
    };
  },
  watch:{
    popupMsg(n){
      // console.log(n,"监听");
      if(n){
        this.popup()
      }
    }
  },
  created() {
    console.log("create");
    this.isLoading();
    this.$store.dispatch("base/getPage");
  },
  methods: {
    popup() {
      var that = this;
      var timer = null;
      console.log(this.popupMsg, "pop");
      if (this.popupMsg) {
        newSwal();
      }
      function newSwal() {
        let html = "";
        for (let index = 0; index < that.popupMsg.child.length; index++) {
          html += `<div id='${that.popupMsg.child[index].slug}' style="display: none">${that.popupMsg.child[index].description}	</div>`;
        }

        // <div id="home-tab2" style="display: none">
        // 	  <p> ${that.popupMsg.child[0].description}</p>
        // 	</div>
        Swal.fire({
          title: that.popupMsg.title,
          html:
            `<div>
							<h1></h1>
							<div>
                ${that.popupMsg.description}
							</div>` +
            html +
            `</div>`,
          confirmButtonText: `<span id="count"><span> ${that.$lang(
            "我知道了"
          )}`,
          allowOutsideClick: false,
          showConfirmButton: true,
        });
        Swal.getConfirmButton().style.display = "none";
      }

      function countDown(s = 5) {
        clearInterval(timer);
        Swal.disableButtons();
        document.getElementById("count").innerHTML = `${that.$lang(
          "我知道了"
        )}（${s}）`;
        timer = setInterval(() => {
          s -= 1;
          document.getElementById("count").innerHTML = `${that.$lang(
            "我知道了"
          )}（${s}）`;
          if (s === 0) {
            clearInterval(timer);
            Swal.enableButtons();
            document.getElementById("count").innerHTML = `${that.$lang(
              "我知道了"
            )}`;
          }
        }, 1000);
      }

      process(({ node, attrName, attrValue }) => {
        node.addEventListener("click", () => {
          process(({ node, attrName, attrValue }) => {
            document.getElementById(attrValue).style.display = "none";
          });
          let display = document.getElementById(attrValue).style.display;
          if (display == "none") {
            countDown();
            document.getElementById(attrValue).style.display = "block";
            Swal.getConfirmButton().style.display = "block";
          }
          if (display == "block") {
            document.getElementById(attrValue).style.display = "none";
          }
        });
      });

      function process(cb) {
        let links = document.querySelectorAll(".link");
        links.forEach((node) => {
          Array.from(node.attributes).forEach((attr) => {
            const attrName = attr.name;
            const attrValue = attr.value;
            if (attrName === "data-target") {
              cb({
                node,
                attrName,
                attrValue,
              });
            }
          });
        });
      }
    },
    isLoading() {
      this.loading = true;
      Promise.all([this.getRecordList(), this.getGroupList()])
        .then((resp) => {       
        })
        .catch((err) => {
          console.log(err);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    // 获取报名表记录
    getRecordList() {
      const params = {
        publicType: "publicGroup",
      };
      return $apis.carnival
        .recordList(params)
        .then((resp) => {
          if (resp.data.isFull === true) {
            this.notification.error(this.$lang(resp.data.fullMessage));
            this.buttonStatus = true;
          }
          this.records = resp.data.records;
        })
        .catch((err) => {
          console.log(err);
        });
    },
    getGroupList() {
      const params = {
        publicType: "publicInstitutionsGroup",
      };
      return $apis.carnival
        .recordList(params)
        .then((resp) => {
          this.groups = resp.data.records;
        })
        .catch((err) => {
          console.log(err);
        });
    },
    // 删除报名表记录
    deleteRecordDetail(id) {
      $apis.carnival
        .deleteRecordDetail({
          id,
        })
        .then((resp) => {
          this.notification.success(this.$lang("删除成功"));
          this.getRecordList();
        })
        .catch((err) => {
          this.notification.error(this.$lang("删除失败"));
          console.log(err);
        });
    },
    // 正式提交表明表记录
    formalSubmission(id) {
      $apis.carnival
        .formalSubmission({ id })
        .then((resp) => {
          this.notification.success(this.$lang("提交成功"));
          this.getRecordList();
          this.getGroupList();
        })
        .catch((err) => {
          this.notification.success(this.$lang("提交失败"));
          console.log(err);
        });
    },
    handlerDelete(id) {
      let r = confirm(this.$lang("是否刪除報名表!"));
      if (r == true) {
        this.deleteRecordDetail(id);
      }
    },
    handlerSumbit(id) {
      let r = confirm(this.$lang("是否確認提交!"));
      if (r == true) {
        this.formalSubmission(id);
      }
    },
    openModel(val) {
      if (val === 2) {
        this.$router.push({
          path: "sport-game",
          query: { type: "group" },
        });
      } else {
        this.$router.push({
          path: "sport-game",
        });
      }
    },
  },
  computed: {
    popupMsg() {
      return this.$store.state.base.SummerCarnival2019PopupMsg;
    },
    summerGuidelines() {
      return this.$store.state.base.summerGuidelines;
    },
    isEnroll() {
      return this.records.length || 0;
    },
    isGroup() {
      return this.groups.length || 0;
    },
  },
};
</script>
